module.exports = __webpack_public_path__ + "/images/cover-acompanamos-embarazo-en.f83c363.webp";